import React, {Component} from 'react';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import IconCard from '../../Components/Member/IconCard';
import Api from '../../Components/Api';

UIkit.use(Icons);

export default class DashboardCampaign extends Component {

  state = {
    campaign: <span uk-spinner=""></span>
  }

  componentDidMount() {
    this.userGet();
  }

  async userGet() {
    var {campaign} = await Api.member('DashboardCampaign');
    this.setState({campaign: '+ ' + campaign});
  }

  render() {
    return <IconCard option={{
      backgroundColorLeft: '#ff864a',
      backgroundColorRight: '#ffa87d',
      icon: 'flag',
      title: 'Campaign',
      caption:  this.state.campaign || 0
    }} />
  }
};
